/** Estados de export do Replay de cidade (Épico 38). */
export const REPLAY_EXPORT_STATE = {
  IDLE: 'idle',
  RECORDING: 'recording',
  DONE: 'done',
  UNSUPPORTED: 'unsupported',
  ERROR: 'error',
};

export function isMediaRecorderSupported() {
  return typeof window !== 'undefined' && typeof window.MediaRecorder !== 'undefined';
}

export function initialReplayExportState() {
  return isMediaRecorderSupported()
    ? REPLAY_EXPORT_STATE.IDLE
    : REPLAY_EXPORT_STATE.UNSUPPORTED;
}

export function resetReplayExportState() {
  return initialReplayExportState();
}
